import { HeroIcon } from '@components/HeroIcon'
import { Text, useWindowDimensions, XStack, YStack } from 'tamagui'

export function OfflineCoverPage() {
  const { height } = useWindowDimensions()

  const paddingTop = height * 0.25

  return (
    <YStack ai="center" h="100%" bg="$background-100" pt={paddingTop}>
      <XStack paddingHorizontal="$spacing-inset-xs">
        <YStack
          ai="center"
          gap="$spacing-inset-sm"
          paddingHorizontal="$spacing-inset-sm"
        >
          <XStack
            borderRadius="$border-radius-pill"
            bg="$neutral-0"
            p="$spacing-inset-xs"
          >
            <HeroIcon
              icon={['fal', 'wifi-slash']}
              size={40}
              color="$neutral-800"
            />
          </XStack>

          <YStack gap="$spacing-inset-xs" paddingHorizontal={20}>
            <YStack>
              <Text
                ff="$mulishRegular"
                fontSize="$font-size-md"
                color="$neutral-800"
                fontWeight="700"
                textAlign="center"
              >
                Parece que você está
              </Text>
              <Text
                ff="$mulishRegular"
                fontSize="$font-size-md"
                color="$neutral-800"
                fontWeight="700"
                textAlign="center"
              >
                sem conexão
              </Text>
            </YStack>

            <YStack>
              <Text
                ff="$mulishRegular"
                fontSize="$font-size-xs"
                color="$neutral-800"
                textAlign="center"
                fontWeight="300"
              >
                Verifique sua rede e tente novamente
              </Text>

              <Text
                ff="$mulishRegular"
                fontSize="$font-size-xs"
                color="$neutral-800"
                textAlign="center"
                fontWeight="300"
              >
                mais tarde.
              </Text>
            </YStack>
          </YStack>
        </YStack>
      </XStack>
    </YStack>
  )
}
